import React, {Component} from "react";

class AsideComponent extends Component {

    state = {
        slideState: 0,
        openedFaqItems:[]
    }

    quickTipArr = [
        {
            "id":1,
            slideText:"You can easily create new policy for different websites."
        },
        {
            "id":2,
            slideText:"You can test your tool on sandbox mode."
        },
        {
            "id":3,
            slideText:"You can edit design colours from website detail page."
        }
    ]


    changeSlideIndex = (direction) => {
        this.setState({
            slideState:(this.state.slideState+direction)<0?this.quickTipArr.length-1 : (this.state.slideState+direction)%this.quickTipArr.length
        })
    }

    toggleFaqItem = (index) => {
        let clickedIndex = this.state.openedFaqItems.indexOf(index);
        if(clickedIndex===-1){
            this.setState({
                openedFaqItems:[...this.state.openedFaqItems,index]
            })
        }else{
            this.setState({
                openedFaqItems:[...this.state.openedFaqItems.slice(0,clickedIndex),...this.state.openedFaqItems.slice(clickedIndex+1)]
            })
        }
    }
    render() {

        let slideText, slideNumber;

        switch (this.state.slideState) {
            case 1:
                slideText = "You can easily create new policy for different websites."
                slideNumber = "1"
                break;
            case 2:
                slideText = "You can test your tool on sandbox mode."
                slideNumber = "2"
                break;
            case 3:
                slideText = "You can edit design colours from website detail page."
                slideNumber = "3"
                break;
        }

        return (
            // TODO --> tips clası geldiiğinde sdk bölümü gözükür faq geldiğind e faq blogu gözükür
            <aside className="aside-root ">
                <div className="aside-container">
                    <div className="aside-block quick">
                        <div className="quick-top-container">
                            <div className="quick-title-item">
                                <i>
                                    <svg width="16" height="17" viewBox="0 0 16 17" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M14.2591 4.25503C14.2217 4.20311 14.1664 4.16687 14.1039 4.15326C14.0414 4.13965 13.9761 4.14964 13.9205 4.18131C13.4814 4.4315 12.9806 4.55226 12.4759 4.52965C11.9134 4.50092 11.3734 4.29991 10.9287 3.95379C10.4841 3.60767 10.1563 3.13315 9.98965 2.59438C9.87259 2.22614 9.83865 1.83646 9.89027 1.45349C9.9005 1.38929 9.88633 1.32357 9.85056 1.26932C9.81479 1.21507 9.76001 1.17622 9.69704 1.16043C8.69776 0.923007 7.66139 0.886261 6.64784 1.05232C5.63429 1.21838 4.66365 1.58394 3.79199 2.1279C2.92033 2.67186 2.16493 3.38342 1.56945 4.22147C0.973966 5.05952 0.550201 6.00745 0.322638 7.01049C0.311699 7.06649 0.318818 7.12452 0.342965 7.1762C0.367113 7.22789 0.40704 7.27055 0.456978 7.29801C0.684623 7.43007 0.872779 7.62081 1.00187 7.85039C1.13096 8.07996 1.19628 8.33999 1.19102 8.60342C1.18576 8.86684 1.11011 9.12405 0.97196 9.34827C0.833806 9.57249 0.638185 9.75554 0.40545 9.87838C0.3548 9.90362 0.313542 9.94443 0.287714 9.99483C0.261886 10.0452 0.252844 10.1026 0.261908 10.1585C0.598103 11.9663 1.56234 13.5965 2.98378 14.7604C4.40523 15.9242 6.19213 16.5466 8.0279 16.5173C11.9808 16.4565 15.4847 13.0615 15.6688 9.10612C15.7538 7.3767 15.2575 5.66865 14.2591 4.25503ZM4.22404 13.2697C4.10829 13.2697 3.99515 13.2353 3.89891 13.1709C3.80268 13.1065 3.72767 13.015 3.68337 12.9079C3.63908 12.8008 3.62749 12.683 3.65007 12.5693C3.67265 12.4556 3.72839 12.3511 3.81023 12.2692C3.89207 12.1872 3.99635 12.1314 4.10987 12.1088C4.22339 12.0861 4.34106 12.0977 4.44799 12.1421C4.55492 12.1865 4.64632 12.2616 4.71062 12.358C4.77492 12.4544 4.80925 12.5677 4.80925 12.6836C4.80925 12.7606 4.79411 12.8368 4.7647 12.9079C4.73529 12.979 4.69219 13.0436 4.63785 13.0981C4.58351 13.1525 4.51899 13.1957 4.44799 13.2251C4.37699 13.2546 4.30089 13.2697 4.22404 13.2697ZM6.45262 10.3779C5.9467 10.3779 5.45213 10.2276 5.03147 9.9461C4.61081 9.66459 4.28295 9.26447 4.08935 8.79634C3.89574 8.32821 3.84508 7.81309 3.94378 7.31613C4.04248 6.81916 4.2861 6.36266 4.64385 6.00437C5.00159 5.64608 5.45738 5.40208 5.95358 5.30322C6.44978 5.20437 6.96411 5.25511 7.43153 5.44901C7.89894 5.64292 8.29844 5.97129 8.57952 6.3926C8.86059 6.81391 9.01062 7.30923 9.01062 7.81594C9.01062 8.4954 8.74112 9.14704 8.2614 9.62749C7.78168 10.1079 7.13104 10.3779 6.45262 10.3779ZM9.86819 14.7368C9.54061 14.7368 9.22039 14.6396 8.94802 14.4573C8.67565 14.275 8.46337 14.0159 8.33801 13.7128C8.21265 13.4097 8.17985 13.0762 8.24376 12.7544C8.30767 12.4326 8.46541 12.1371 8.69704 11.9051C8.92867 11.6731 9.22379 11.5151 9.54507 11.4511C9.86635 11.3871 10.1994 11.4199 10.502 11.5455C10.8047 11.6711 11.0633 11.8837 11.2453 12.1565C11.4273 12.4292 11.5244 12.75 11.5244 13.078C11.5244 13.518 11.3499 13.9399 11.0393 14.251C10.7287 14.5621 10.3075 14.7368 9.86819 14.7368ZM12.9801 9.7125C12.7949 9.71214 12.614 9.65681 12.4602 9.5535C12.3064 9.45019 12.1866 9.30355 12.116 9.13209C12.0454 8.96064 12.0271 8.77207 12.0635 8.59021C12.0998 8.40834 12.1892 8.24135 12.3203 8.11034C12.4513 7.97932 12.6182 7.89015 12.7999 7.8541C12.9815 7.81805 13.1698 7.83674 13.3408 7.9078C13.5119 7.97886 13.6581 8.0991 13.7609 8.25334C13.8638 8.40758 13.9187 8.58888 13.9187 8.77435C13.9187 8.89786 13.8943 9.02016 13.847 9.13422C13.7997 9.24828 13.7304 9.35187 13.643 9.43903C13.5556 9.52619 13.4519 9.59522 13.3379 9.64215C13.2238 9.68908 13.1016 9.71299 12.9783 9.7125H12.9801Z"
                                            fill="white"/>
                                    </svg>
                                </i>
                                <h3>Quick Tip</h3>
                            </div>
                            <div className="slide-item">
                                <span className="slide-icon" onClick={()=>{this.changeSlideIndex(-1)}}>
                                    <svg width="6" height="7" viewBox="0 0 6 7" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M4.4453 0.536466C5.10986 0.0934299 6 0.569822 6 1.36852V5.63148C6 6.43018 5.10985 6.90657 4.4453 6.46353L1.24808 4.33205C0.654342 3.93623 0.654342 3.06377 1.24808 2.66795L4.4453 0.536466Z"
                                            fill="white"/>
                                    </svg>
                                </span>
                                <span className="slide-number">{(this.state.slideState+1)}/{this.quickTipArr.length}</span>
                                <span className="slide-icon" onClick={()=>{this.changeSlideIndex(1)}}>
                                    <svg width="6" height="7" viewBox="0 0 6 7" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M1.5547 0.536466C0.890145 0.0934299 0 0.569822 0 1.36852V5.63148C0 6.43018 0.890145 6.90657 1.5547 6.46353L4.75192 4.33205C5.34566 3.93623 5.34566 3.06377 4.75192 2.66795L1.5547 0.536466Z"
                                            fill="white"/>
                                    </svg>
                                </span>
                            </div>
                        </div>
                        <div className="text-item">
                            <span>{this.quickTipArr[this.state.slideState].slideText}</span>
                        </div>
                    </div>
                </div>
                <div className="aside-container">
                    <div className="title-item">
                        <span>FAQ</span>
                    </div>
                    <div className="aside-block faq">
                        <div className={`aside-item ${this.state.openedFaqItems.indexOf(0)>-1 ? "active" : ""}`} onClick={() => {
                            this.toggleFaqItem(0)
                        }}>
                            <div className="title-block">
                                <span>What is policy?</span>
                            </div>
                            <div className="text-block">
                                <p>
                                Policy is a feature that you can create for one or more sites and define rules according to these sites. </p>
                            </div>
                        </div>
                        {/* TODO --> active classı alatına gelecek yazı açar */}
                        <div className={`aside-item ${this.state.openedFaqItems.indexOf(1)>-1 ? "active" : ""}`} onClick={() => {
                            this.toggleFaqItem(1)
                        }}>
                            <div className="title-block">
                                <span>How can I create new policy template?</span>
                            </div>
                            <div className="text-block">
                                <p>
                                You can see your policies from Policies Menu. With "New Policy" button, you can create your own. </p>
                            </div>
                        </div>
                        {/* <div className={`aside-item ${this.state.openedFaqItems.indexOf(2)>-1 ? "active" : ""}`} onClick={() => {
                            this.toggleFaqItem(2)
                        }}>
                            <div className="title-block">
                                <span>What is the default audiences meaning?</span>
                            </div>
                            <div className="text-block">
                                <p>
                                    Vestibulum vestibulum dapibus scelerisque. Aliquam blandit dignissim mauris nec mollis. Nunc molestie bibendum ornare.
                                </p>
                                <p>
                                    Donec sed aliquet dui. Nunc imperdiet nunc sed leo varius, ac pellentesque urna elementum. Suspendisse vehicula tempor finibus. Mauris suscipit vestibulum purus, id dictum purus mattis vitae.
                                </p>
                            </div>
                        </div> */}
                    </div>
                </div>
            </aside>
        );
    }
}

export default AsideComponent;
